module.exports = __webpack_public_path__ + "img/law4-m@2.786fac28.webp";